import React from "react";
import Order from "../../components/Order/Order";

const OrderPage = () => {
  return (
    <div>
      <Order />
    </div>
  );
};

export default OrderPage;
